import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { animated, useSpring } from '@react-spring/web'

import './styles.css'

const Menu = ({open, setOpen}) => {
  const navigate = useNavigate()

  // animation state
  const [animate, setAnimate] = useState(true)

  const onClick = (destination) => {
    navigate(`/renormalization/${destination}`)
    setOpen(false)
  }

  const slideOpen = useSpring({
    from: { height: '0%'},
    to: { height: open ? '100%' : '0%'}
  })

  return (
    
    <animated.nav 
      style={slideOpen}
      className={`menu-container ${open ? 'menu-open' : 'menu-closed'}`}>
        <ul className='menu-items'>
            <li className={`menu-item ${open ? 'menu-item-open' : 'menu-item-closed'}`} onClick={() => onClick('')}>Home</li>
            <li className={`menu-item ${open ? 'menu-item-open' : 'menu-item-closed'}`} onClick={() => onClick('science')}>The Science</li>
            <li className={`menu-item ${open ? 'menu-item-open' : 'menu-item-closed'}`} onClick={() => onClick('papers')}>Papers</li>
            <li className={`menu-item ${open ? 'menu-item-open' : 'menu-item-closed'}`} onClick={() => onClick('about')}>About</li>
        </ul>
    </animated.nav>
  )
}

export default Menu